/**
 * Localization strings for app resources
 *
 * @module
 */

import { createDictionary } from './utils';

// Refer to "Guidelines for Programmers" in ./README.md before editing this file

export const resourcesText = createDictionary({
  appResources: {
    'en-us': 'App Resources',
    'ru-ru': 'Ресурсы приложения',
    'es-es': 'Recursos de la aplicación',
    'fr-fr': "Ressources de l'application",
    'uk-ua': 'Ресурси програми',
    'de-ch': 'App Ressourcen',
  },
  formDefinition: {
    'en-us': 'Form Definition',
    'ru-ru': 'Схема формы',
    'es-es': 'Definición del formulario',
    'fr-fr': 'Définition du formulaire',
    'uk-ua': 'Визначення форми',
    'de-ch': 'Formular Definition',
  },
  formDefinitions: {
    'en-us': 'Form Definitions',
    'ru-ru': 'Определения форм',
    'es-es': 'Definiciones de formulario',
    'fr-fr': 'Définitions de formulaire',
    'uk-ua': 'Визначення форм',
    'de-ch': 'Formular Definitionen',
  },
  loadFile: {
    'en-us': 'Load File',
    'ru-ru': 'Загрузить файл',
    'es-es': 'Cargar archivo',
    'fr-fr': 'Fichier de chargement',
    'uk-ua': 'Завантажити файл',
    'de-ch': 'Datei Laden',
  },
  globalResources: {
    'en-us': 'Global Resources',
    'ru-ru': 'Глобальные ресурсы',
    'es-es': 'Recursos globales',
    'fr-fr': 'Ressources globales',
    'uk-ua': 'Глобальні ресурси',
    'de-ch': 'Globale Ressourcen',
  },
  disciplineResources: {
    'en-us': 'Discipline Resources',
    'ru-ru': 'Ресурсы дисциплины',
    'es-es': 'Recursos de disciplina',
    'fr-fr': 'Ressources de discipline',
    'uk-ua': 'Ресурси Дисципліни',
    'de-ch': 'Disziplin-Ressourcen',
  },
  type: {
    'en-us': 'Type',
    'ru-ru': 'Тип',
    'es-es': 'Tipo',
    'fr-fr': 'Type',
    'uk-ua': 'Тип',
    'de-ch': 'Typ',
  },
  userTypes: {
    'en-us': 'User Types',
    'ru-ru': 'Типы пользователей',
    'es-es': 'Tipos de usuario',
    'fr-fr': "Types d'utilisateur",
    'uk-ua': 'Типи користувачів',
    'de-ch': 'Benutzertypen',
  },
  resources: {
    'en-us': 'Resources',
    'ru-ru': 'Ресурсы',
    'es-es': 'Recursos',
    'fr-fr': 'Ressources',
    'uk-ua': 'Ресурси',
    'de-ch': 'Ressourcen',
  },
  subCategories: {
    'en-us': 'Sub-categories',
    'ru-ru': 'Подкатегории',
    'es-es': 'Subcategorías',
    'fr-fr': 'Sous-catégories',
    'uk-ua': 'Підкатегорії',
    'de-ch': 'Unterkategorien',
  },
  addResource: {
    'en-us': 'Add Resource',
    'ru-ru': 'Добавить ресурс',
    'es-es': 'Agregar recurso',
    'fr-fr': 'Ajouter une ressource',
    'uk-ua': 'Додати ресурс',
    'de-ch': 'Ressource hinzufügen',
  },
  appResource: {
    'en-us': 'App Resource',
    'ru-ru': 'Ресурс приложения',
    'es-es': 'Recurso de aplicación',
    'fr-fr': "Ressource d'application",
    'uk-ua': 'Ресурс програми',
    'de-ch': 'App Ressource',
  },
  rssExportFeed: {
    'en-us': 'RSS Export Feed',
    'ru-ru': 'RSS-канал экспорта',
    'es-es': 'Exportar fuente RSS',
    'fr-fr': "Flux d'exportation RSS",
    'uk-ua': 'Канал експорту RSS',
    'de-ch': 'RSS-Export-Feed',
  },
  expressSearchConfig: {
    'en-us': 'Express Search Config',
    'ru-ru': 'Конфигурация быстрого поиска',
    'es-es': 'Configuración de búsqueda rápida',
    'fr-fr': 'Configuration de la recherche express',
    'uk-ua': 'Конфігурація експрес-пошуку',
    'de-ch': 'Express Suche Konfigurieren',
  },
  webLinks: {
    'en-us': 'Web Links',
    'ru-ru': 'Веб-ссылки',
    'es-es': 'Enlaces web',
    'fr-fr': 'Liens Web',
    'uk-ua': 'Веб-посилання',
    'de-ch': 'Weblinks',
  },
  uiFormatters: {
    'en-us': 'Field formatters',
    'ru-ru': 'Форматировщики полей',
    'es-es': 'Formateadores de campo',
    'fr-fr': 'Formateurs de champ',
    'uk-ua': 'Форматери полів',
    'de-ch': 'Feld-Formatierer',
  },
  dataObjectFormatters: {
    'en-us': 'Record Formatters',
    'ru-ru': 'Форматировщики записей',
    'es-es': 'Formateadores de registros',
    'fr-fr': "Formateurs d'enregistrement",
    'uk-ua': 'Форматери записів',
    'de-ch': 'Datensatz-Formatierer',
  },
  searchDialogDefinitions: {
    'en-us': 'Search Dialog Definitions',
    'ru-ru': 'Макеты диалогового окна поиска',
    'es-es': 'Definiciones del cuadro de diálogo buscar',
    'fr-fr': 'Définitions de la boîte de dialogue de recherche',
    'uk-ua': 'Визначення діалогових вікон пошуку',
    'de-ch': 'Suchdialog-Definitionen',
  },
  dataEntryTables: {
    'en-us': 'Data Entry Tables',
    'ru-ru': 'Таблицы ввода данных',
    'es-es': 'Tablas de entrada de datos',
    'fr-fr': 'Tableaux de saisie de données',
    'uk-ua': 'Таблиці введення даних',
    'de-ch': 'Dateneingabetabellen',
  },
  interactionsTables: {
    'en-us': 'Interactions Tables',
    'ru-ru': 'Таблицы взаимодействий',
    'es-es': 'Tablas de interacciones',
    'fr-fr': "Tableaux d'interactions",
    'uk-ua': 'Таблиці взаємодій',
    'de-ch': 'Interaktionstabellen',
  },
  otherXmlResource: {
    'en-us': 'Other XML Resource',
    'ru-ru': 'Другой XML-ресурс',
    'es-es': 'Otro recurso XML',
    'fr-fr': 'Autre ressource XML',
    'uk-ua': 'Інший ресурс XML',
    'de-ch': 'Andere XML-Ressource',
  },
  otherJsonResource: {
    'en-us': 'Other JSON Resource',
    'ru-ru': 'Другой JSON-ресурс',
    'es-es': 'Otro recurso JSON',
    'fr-fr': 'Autre ressource JSON',
    'uk-ua': 'Інший ресурс JSON',
    'de-ch': 'Andere JSON-Ressource',
  },
  otherPropertiesResource: {
    'en-us': 'Other Properties Resource',
    'ru-ru': 'Другой Properties-ресурс',
    'es-es': 'Otro recurso de propiedades',
    'fr-fr': 'Autre ressource de propriétés',
    'uk-ua': 'Ресурс властивостей',
    'de-ch': 'Andere Eigenschaften Ressource',
  },
  otherAppResource: {
    'en-us': 'Other Resource',
    'ru-ru': 'Другой Ресурс',
    'es-es': 'Otro recurso',
    'fr-fr': 'Autre ressource',
    'uk-ua': 'Інший ресурс',
    'de-ch': 'Andere Ressource',
  },
  filters: {
    'en-us': 'Filters',
    'ru-ru': 'Фильтры',
    'es-es': 'Filtros',
    'fr-fr': 'Filtres',
    'uk-ua': 'Фільтри',
    'de-ch': 'Filter',
  },
  custom: {
    'en-us': 'Custom',
    'ru-ru': 'Настроить',
    'es-es': 'Personalizado',
    'fr-fr': 'Personnalisé',
    'uk-ua': 'Custom',
    'de-ch': 'Individuell',
  },
  leafletLayers: {
    'en-us': 'Leaflet Layers',
    'ru-ru': 'Слои Leaflet',
    'es-es': 'Capas de folleto',
    'fr-fr': 'Couches de brochures',
    'uk-ua': 'Шари Leaflet карти',
    'de-ch': 'Leaflet-Layer',
  },
  textEditor: {
    'en-us': 'Text Editor',
    'ru-ru': 'Текстовый редактор',
    'es-es': 'Editor de texto',
    'fr-fr': 'Éditeur de texte',
    'uk-ua': 'Текстовий редактор',
    'de-ch': 'Text-Editor',
  },
  visualEditor: {
    'en-us': 'Visual Editor',
    'ru-ru': 'Визуальный редактор',
    'es-es': 'Editor visual',
    'fr-fr': 'Éditeur visuel',
    'uk-ua': 'Візуальний редактор',
    'de-ch': 'Visueller Editor',
  },
  selectResourceType: {
    'en-us': 'Select Resource Type',
    'ru-ru': 'Выберите тип ресурса',
    'es-es': 'Seleccionar el tipo de recurso',
    'fr-fr': 'Sélectionnez le type de ressource',
    'uk-ua': 'Виберіть тип ресурсу',
    'de-ch': 'Ressourcentyp auswählen',
  },
  globalPreferences: {
    'en-us': 'Global Preferences',
    'ru-ru': 'Глобальные настройки',
    'es-es': 'Preferencias globales',
    'fr-fr': 'Préférences globales',
    'uk-ua': 'Глобальні налаштування',
    'de-ch': 'Globale Einstellungen',
  },
  remotePreferences: {
    'en-us': 'Remote Preferences',
    'ru-ru': 'Удаленные настройки',
    'es-es': 'Preferencias en remoto',
    'fr-fr': 'Préférences distantes',
    'uk-ua': 'Віддалені параметри',
    'de-ch': 'Remote-Einstellungen',
  },
} as const);
